import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import isBrowser from 'utils/isBrowser';
import { Sentry } from 'root/utils/raven';

const initialState = {
  items: {},
  isLoading: true,
  error: null
};

const pagesSlice = createSlice({
  name: 'pages',
  initialState,
  reducers: {
    getPageStart(state) {
      state.isLoading = true;
    },
    getPageSuccess(state, { payload: { slug, data } }) {
      state.items[slug] = data;
      state.isLoading = false;
      state.error = null;
    },
    getPageFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getPageStart,
  getPageSuccess,
  getPageFailure,
} = pagesSlice.actions;

export default pagesSlice.reducer;

export const fetchPage = (slug) => async (dispatch, getState) => {
  const { pages } = getState();
  if (pages.items[slug] && !pages.items[slug]?.length) {
    dispatch(getPageSuccess({
      slug,
      data: pages.items[slug],
    }));
  } else {
    try {
      dispatch(getPageStart());
      const data = await apiClient({ method: 'GET', url: `/wp-json/mc/v1/pages/${slug}` });
      dispatch(getPageSuccess({
        slug,
        data,
      }));
    } catch (e) {
      dispatch(getPageFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const fetchPagePreview = (id, wpnonce, cookie) => async (dispatch) => {
  const url = `/wp-json/mc/v1/pages/${id}/preview?_wpnonce=${wpnonce}`;
  const config = {
    withCredentials: true,
  };

  if (isBrowser()) {
    config.headers = {
      Cookie: cookie,
    };
  }

  try {
    dispatch(getPageStart());
    const data = await apiClient({ method: 'GET', url, params: { config } });
    dispatch(getPageSuccess({
      slug: id,
      data,
    }));
  } catch (e) {
    dispatch(getPageFailure(e.toString()));
    Sentry.captureException(e);
  }
};

export const setPage = ({ slug, data }) => getPageSuccess({
  slug,
  data,
});
